import RequestV2 from './request-v2';

export default class InterestRateHttpService {
    private static uri = 'interest-rate';

    public static getInterestRates() {
        return RequestV2.get(`${this.uri}`);
    }

    public static async saveInterestRate(rate: any) {
        return RequestV2.post(`${this.uri}`, rate);
    }

    public static async editInterestRate(rate: any) {
        return RequestV2.put(`${this.uri}`, rate);
    }

    public static async deleteInterestRate(id?: number) {
        return RequestV2.del(`${this.uri}/${id}`);
    }
}
